"use client";

import React from "react";

import { ImageBannerProps } from "@/types/policy-document-types";

import Logo from "../../logo-component/logo";
import Styles from "../policy-document-section.module.css";

function ThankYouContent({
  imageBannerTitle,
  imageBannerContent,
  havDoc,
}: Readonly<ImageBannerProps & { havDoc: boolean }>) {
  return (
    <div
      className="flex flex-col gap-spacing-xs md:gap-spacing-m lg:gap-spacing-l "
      data-testid="thankyou-section-testid"
    >
      <div className="flex flex-col gap-spacing-m ">
        <Logo
          color="white"
          size="xl"
          className={`!p-0 m-0 hidden lg:block ${Styles.logo}`}
        />
        <h1 className=" font-header-font text-[23px] md:text-[39px] leading-[27.6px] md:leading-[44.85px] text-left text-dark-text-title lg:py-0">
          {imageBannerTitle ?? ""}
        </h1>
      </div>
      {havDoc && (
        <div className=" text-xs leading-[27px] text-left text-dark-text-title lg:py-0 ">
          {imageBannerContent ?? ""}
        </div>
      )}
    </div>
  );
}

export default ThankYouContent;
